module.exports = __webpack_public_path__ + "img/dinamo-zagreb-logo-icon.7d5486d5.png";